// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__kZX8P","label":"SetPasswdForm_label__3O3or"};